// Assistant Action Creators

export const setAssistant = (payload) => ({
  payload,
  type: 'SET_ASSISTANT'
})

export const setExpandChat = (payload) => ({
  payload,
  type: 'SET_EXPANDE_CHAT'
})

// Chat Actions
export const sendMessage = (message) => ({
  type: 'SEND_MESSAGE',
  payload: message
});

export const receiveMessage = (message) => ({
  type: 'RECEIVE_MESSAGE',
  payload: message
});

export const setTyping = (isTyping) => ({
  type: 'SET_TYPING',
  payload: isTyping
});

export const clearMessages = () => ({
  type: 'CLEAR_MESSAGES'
});

export const setChatError = (error) => ({
  type: 'SET_CHAT_ERROR',
  payload: error
});

// MCP Server Actions
export const getAllMCPServers = () => ({
  type: 'GET_ALL_MCP_SERVERS'
});

export const setAllMCPServers = (data) => ({
  type: 'SET_ALL_MCP_SERVERS',
  payload: data
});

export const createMCPServer = (data) => ({
  type: 'CREATE_MCP_SERVER',
  payload: data
});

export const updateMCPServer = (serverName, data) => ({
  type: 'UPDATE_MCP_SERVER',
  payload: { serverName, data }
});

export const deleteMCPServer = (serverName) => ({
  type: 'DELETE_MCP_SERVER',
  payload: serverName
});

export const connectMCPServer = (serverName) => ({
  type: 'CONNECT_MCP_SERVER',
  payload: serverName
});

export const disconnectMCPServer = (serverName) => ({
  type: 'DISCONNECT_MCP_SERVER',
  payload: serverName
});

export const executeMCPTool = (serverName, toolName, args) => ({
  type: 'EXECUTE_MCP_TOOL',
  payload: { serverName, toolName, args }
});

export const updateToolCustomization = (serverName, toolName, data) => ({
  type: 'UPDATE_TOOL_CUSTOMIZATION',
  payload: { serverName, toolName, data }
});

export const removeToolCustomization = (serverName, toolName) => ({
  type: 'REMOVE_TOOL_CUSTOMIZATION',
  payload: { serverName, toolName }
});

// Assistant State Actions
export const setAssistantLoading = (isLoading) => ({
  type: 'SET_ASSISTANT_LOADING',
  payload: isLoading
});

export const setMCPError = (error) => ({
  type: 'SET_MCP_ERROR',
  payload: error
});

export const setExecutingTool = (toolName) => ({
  type: 'SET_EXECUTING_TOOL',
  payload: toolName
});

export const setToolExecutionResult = (result) => ({
  type: 'SET_TOOL_EXECUTION_RESULT',
  payload: result
});

// Send chat message to AI
export const sendChatMessage = (message, threadId) => ({
  type: 'SEND_CHAT_MESSAGE',
  payload: { message, threadId }
});

// Thread Actions
export const getThreads = () => ({
  type: 'GET_THREADS'
});

export const setThreads = (threads) => ({
  type: 'SET_THREADS',
  payload: threads
});

export const getThreadMessages = (threadId) => ({
  type: 'GET_THREAD_MESSAGES',
  payload: threadId
});

export const setThreadMessages = (threadId, messages) => ({
  type: 'SET_THREAD_MESSAGES',
  payload: { threadId, messages }
});

export const setCurrentThread = (threadId) => ({
  type: 'SET_CURRENT_THREAD',
  payload: threadId
});

export const deleteThread = (threadId) => ({
  type: 'DELETE_THREAD',
  payload: threadId
});

export const exportThread = (threadId, format) => ({
  type: 'EXPORT_THREAD',
  payload: { threadId, format }
});

export const setThreadsLoading = (isLoading) => ({
  type: 'SET_THREADS_LOADING',
  payload: isLoading
});

// Audio Recording Actions
export const transcribeAudio = (payload) => ({
  type: 'TRANSCRIBE_AUDIO',
  payload
});

export const updateMessageFeedback = (payload) => ({
  type: 'UPDATE_MESSAGE_FEEDBACK',
  payload
});